const scope = state => state.preferences;

export const getPreferences = state => scope(state).preferences;
export const getPreferenceSecurity = state => scope(state).preferenceSecurity;
export const getPreferencesLoaded = state => scope(state).preferencesLoaded;
export const getPreferencesLoading = state => scope(state).preferencesLoading;
export const getPreferencesSaving = state => scope(state).preferencesSaving;
export const getPreferencesError = state => scope(state).preferencesError;
